export const MARKETPLACE_FETCHER_ACTIONS = {
    FETCH_DATA_SUCCESS : "FETCH_MARKETPLACE_DATA_SUCCESS",
    FETCH_DATA_FAILURE : "FETCH_MARKETPLACE_DATA_FAILURE",
}